// @flow
import gql from 'graphql-tag'
import { type Address, ADDRESS_FIELDS_FRAGMENT } from 'gql/address'
import { type Klass } from 'gql/class'

export const SCHOOL_FIELDS_FRAGMENT = gql`
  fragment SchoolFields on School {
    id
    slug
    insertedAt
    name
    licenseNumber
    licenseStatus
    slug
    address {
      ...AddressFields
    }
  }
  ${ADDRESS_FIELDS_FRAGMENT}
`

export type School = {
  id: number,
  slug: string,
  insertedAt: string,
  name: string,
  licenseNumber: string | null,
  licenseStatus: string | null,
  slug: string,
  address: Address | null,
  classes: Klass[],
}
